import { AHText, Card, SectionHeader, TouchableBox } from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";
import { ControlType, RoutineSchedule } from "../RoutineEditNavigation";
import { RoutineEditScheduleWeeklyOptions } from "./RoutineEditScheduleWeeklyOptions";
import { RoutineEditScheduleMonthlyOptions } from "./RoutineEditScheduleMonthlyOptions";
import { RoutineEditScheduleDailyOptions } from "./RoutineEditScheduleDailyOptions";
import { useRoutineEditStateSetParams } from "../../State/RoutineEditState";

type Props = {
  selectedSchedule: RoutineSchedule;
  onOpenTaskImportance(): void;
  controlType: ControlType;
  hasAdvancedScheduling: boolean;
};

export function RoutineEditScheduleCardComponent({
  selectedSchedule: schedule,
  onOpenTaskImportance,
  controlType,
  hasAdvancedScheduling,
}: Props) {
  const showAdvanced =
    hasAdvancedScheduling &&
    controlType === "checklist" &&
    schedule.freq === "daily";

  const setScheduleParams = useRoutineEditStateSetParams();
  return (
    <>
      <SectionHeader
        right={
          showAdvanced ? (
            <TouchableBox onPress={onOpenTaskImportance}>
              <AHText type="subtitle" color="primary">
                <FormattedMessage
                  defaultMessage="Advanced"
                  description="RoutineEditScheduleCardDailyWeekly Advanced Button title"
                />
              </AHText>
            </TouchableBox>
          ) : null
        }
      >
        <SectionHeader.Title>
          <FormattedMessage
            defaultMessage="Schedule"
            description="Routine Admin Edit Overview Schedule Title"
          />
        </SectionHeader.Title>
      </SectionHeader>
      <Card noSpace defaultBorder>
        {schedule.freq === "daily" ? (
          <RoutineEditScheduleDailyOptions
            isAllDay={schedule.isAllDay}
            weekdays={schedule.weekdays}
            setWeekdays={(weekdays) => {
              setScheduleParams({
                scheduleFreq: "daily",
                scheduleDaily: {
                  ...schedule,
                  weekdays,
                },
              });
            }}
            deadlineDuration={schedule.deadlineDuration}
            setDeadlineDuration={(deadlineDuration) => {
              setScheduleParams({
                scheduleFreq: "daily",
                scheduleDaily: {
                  ...schedule,
                  deadlineDuration,
                },
              });
            }}
          />
        ) : schedule.freq === "weekly" ? (
          <RoutineEditScheduleWeeklyOptions
            weeks={schedule.weeks}
            setWeeks={(weeks) => {
              setScheduleParams({
                scheduleFreq: "weekly",
                scheduleWeekly: { ...schedule, weeks },
              });
            }}
            start={schedule.startWeekday}
            end={schedule.endWeekday}
            setRange={({ start, end }) => {
              setScheduleParams({
                scheduleFreq: "weekly",
                scheduleWeekly: {
                  ...schedule,
                  startWeekday: start,
                  endWeekday: end,
                },
              });
            }}
          />
        ) : schedule.freq === "monthly" ? (
          <RoutineEditScheduleMonthlyOptions
            startDay={schedule.startDay}
            setMonthlyParams={(p) => {
              setScheduleParams({
                scheduleFreq: "monthly",
                scheduleMonthly: { ...schedule, ...p },
              });
            }}
            endDay={schedule.endDay}
            months={schedule.months}
          />
        ) : null}
      </Card>
    </>
  );
}
